import {useCallback, useEffect, useState} from 'react'

import BigNumber from 'bignumber.js'
import useDrugs from './useDrugs'
import {useWallet} from 'use-wallet'
import {provider} from 'web3-core'
// import {Contract} from 'web3-eth-contract'

import {getAllowance} from '../utils/erc20'
import {getOriginalGangsterContract, getDrugsContract, /* getHOesStakingContract */} from '../drugs/utils'

const useAllowanceStaking = () => {
  const [allowance, setAllowance] = useState(new BigNumber(0))
  const {account}: { account: string; ethereum: provider } = useWallet()
  const drugs = useDrugs()
  const lpContract = getDrugsContract(drugs)
  const stakingContract = getOriginalGangsterContract(drugs)

  const fetchAllowance = useCallback(async () => {
    const allowance = await getAllowance(
      lpContract,
      account,
      stakingContract.options.address,
    )
    setAllowance(new BigNumber(allowance))
  }, [account, stakingContract, lpContract])

  useEffect(() => {
    if (account && stakingContract && lpContract) {
      fetchAllowance()
    }
    let refreshInterval = setInterval(fetchAllowance, 10000)
    return () => clearInterval(refreshInterval)
  }, [account, stakingContract, lpContract, fetchAllowance])

  return allowance
}

export default useAllowanceStaking
